import type { Object3D } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import type { DeviceModelDefinition } from "./device-model-catalog";
import { cloneSharedModel, markSharedModelResources } from "./shared-model-resources";

export interface DeviceModelLoader {
  load(model: DeviceModelDefinition): Promise<Object3D>;
}

export class DeviceModelLibrary implements DeviceModelLoader {
  private readonly loader = new GLTFLoader();
  private readonly templates = new Map<string, Promise<Object3D>>();

  async load(model: DeviceModelDefinition) {
    return cloneSharedModel(await this.loadTemplate(model));
  }

  private loadTemplate(model: DeviceModelDefinition) {
    const cacheKey = `${model.id}\u0000${model.url}`;
    const cachedTemplate = this.templates.get(cacheKey);
    if (cachedTemplate) {
      return cachedTemplate;
    }

    const template = this.loader.loadAsync(model.url).then((gltf) => {
      markSharedModelResources(gltf.scene);
      return gltf.scene;
    });
    this.templates.set(cacheKey, template);
    return template;
  }
}

export const deviceModelLibrary = new DeviceModelLibrary();
